import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Datatable from "../../ExtraComponents/ReusableTable2";
import {
  getAllQuotes,
  deleteContract,
  createContract,
} from "../../ReduxStore/Slice/Contract/contractSlice";
import { useDispatch } from "react-redux";
import { PenLine, Trash2 } from "lucide-react";
import { DateConvert, DateConvertWithTime } from "../../Utils/CommonFun";
import Swal from "sweetalert2";
import axios from "axios";
import ReactPaginate from "react-paginate";



const AllQuotes = () => {

  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const userDetails = JSON.parse(localStorage.getItem("details"));


  const [allQuoteData, setAllQuoteData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [InputValue, setInputValue] = useState('');


  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  }

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])


  useEffect(() => {
    AllQuote();
  }, [currentPage, pageSize, InputValue]);



  const AllQuote = async () => {
    const req = { agent_id: agent_id, page: currentPage, limit: pageSize, search: InputValue };
    await dispatch(getAllQuotes(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllQuoteData(response.data);
          setTotalRecords(response?.pagination?.total)

        } else {
          setAllQuoteData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

   const handleResendContract = async (row) => {
      console.log("row handleResendContract", row);
      if (row.resend_contract_exist_data != null) {
        // Confirmation dialog
        Swal.fire({
          title: "Are you sure?",
          html: `<div>
             <div>Contract is already sent!</div>
             <div>Do you want to resend this contract?</div>
           </div>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Resend",
          cancelButtonText: "Cancel"
        }).then(async (result) => {
          if (result.isConfirmed) {
  
            // console.log("row.resend_contract_exist_data", JSON.parse(row.resend_contract_exist_data));
            let exist_send_data = JSON.parse(row.resend_contract_exist_data);
  
            // console.log("exist_send_data", exist_send_data.email_template_details);
            // console.log("exist_send_data clientid", exist_send_data.clientid);
  
  
            const req = {
              id: Number(exist_send_data.id),
              step: 4,
              mail_to: exist_send_data.mail_to,
              subject: exist_send_data.subject,
              template_id: exist_send_data.template_id,
              clientid: exist_send_data.clientid,
              ContractOwner: userDetails.id,
              agent_id: exist_send_data.agent_id,
              director_letter: exist_send_data.director_letter,
              self_assessment: exist_send_data.self_assessment,
              payment_type: exist_send_data.payment_type,
              cc_to: exist_send_data.cc_to || "",
              bcc_to: exist_send_data.bcc_to || "",
              email_template_details: exist_send_data.email_template_details
  
            }
  
            // console.log("req", req);
            setLoading(true);
            await dispatch(createContract(req)).unwrap()
              .then((res) => {
                if (res.status) {
                  // console.log("res", res);
                  //setLoading(false);
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: res.message,
                    timer: 3000,
                    timerProgressBar: true,
                  });
                  // setLoading(false);
                  AllQuote();
                  return;
                }
                else {
                  setLoading(false);
                  if (res.message.includes("_____________")) {
  
                    Swal.fire({
                      icon: "warning",
                      title: "Warning..",
                      text: "Signature Tag Is Missing In The Document.",
                      timer: 3000,
                      timerProgressBar: true,
                    });
                    return;
                  } else {
  
                    Swal.fire({
                      icon: "error",
                      title: "Error",
                      text: res.message,
                      timer: 3000,
                      timerProgressBar: true,
                    })
                    return;
                  }
  
                }
              }).catch((err) => {
  
                setLoading(false);
                console.log("err", err);
              })
  
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        });
  
      } else {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "this contract is not sent yet",
          background: "#fff",
          backdrop: "rgba(229, 233, 236, 0.2)",
          customClass: {
            popup: "",
          },
          timer: 3000,
        });
        return;
      }
  
    }
  
    const handleStopReminder = async (row) => {
  
      let stop_remainder_status = row.stop_remainder_status;
      let msg = "Stop";
      if (Number(row.stop_remainder_status) == 1) {
        stop_remainder_status = '0';
        msg = "Start";
      } else {
        stop_remainder_status = '1';
        msg = "Stop";
      }
  
      Swal.fire({
        title: "Are you sure?",
        text: `You want to ${msg} reminder for this contract!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: msg+" Reminder",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const req = { id: row.id, stop_remainder_status: stop_remainder_status, step: 5 };
  
          console.log("req", req);
          await dispatch(createContract(req))
            .unwrap()
            .then((response) => {
              if (response.status) {
                Swal.fire({
                  title: "Success!",
                  text: `Reminder ${msg} successfully.`,

                  icon: "success",
                  showConfirmButton: true,
                  confirmButtonText: "OK",
                   timer: 3000,
                });
                AllQuote();
              } else {
                Swal.fire("Error!", "Something went wrong.", "error");
              }
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          return;
        }
      });
  
    }

  const columns = [
    {
      name: "Subject",
      selector: (row) => row?.subject == null || row?.subject == "" ? "-" : row?.subject,
      sortable: true,
    },
    {
      name: "Client",
      selector: (row) => row?.Client?.client_name,
      sortable: true,
    },
    // {
    //   name: "Yearly Cost",
    //   selector: (row) => row?.yearly_cost,
    //   sortable: true,
    // },
    {
      name: "Created At",
      selector: (row) => DateConvertWithTime(row?.createdAt),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => Number(row?.contract_signed) === 1 ? "Contract Signed" :
        Number(row?.status) === 3 ? "Contract Reviewed" :
          Number(row?.step) === 4 ? "Contract Sent" :
            Number(row?.step) !== 4 ? "In Progress" :
              "-",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          {/* Edit Button (hidden if step is 4) */}
          {Number(row?.step) === 4 ? (
            ""
          ) : (
            <button
              className="btn fs-4 py-0 px-1"
              onClick={() => handleEdit(row)}
              title="Edit"
            >
              <i className="ri-edit-line" />
            </button>
          )}

          {/* Delete Button */}
          <button
            className="btn fs-4 py-0 px-1"
            onClick={() => handleDelete(row)}
            title="Delete"
          >
            <i className="bx bx-trash" />
          </button>

          {/* Download/Convert Button */}
          <button
            className="btn fs-4 py-0 px-1"
            onClick={() => handleConvert(row)}
            title="Download Document"
          >
            <i className="ri-download-2-line" />
          </button>

          {/* Resend Contract Button with appropriate icon */}
          {Number(row?.step) !== 4 ?
            "" :
            <>
              <button
                className="btn fs-4 py-0 px-1"
                onClick={(e) => handleResendContract(row)}
                title="Resend Contract"
              >
                <i className="ri-send-plane-line" />
              </button>



              <button
                className="btn fs-4 py-0 px-1"
                onClick={() => handleStopReminder(row)}
                title={Number(row.stop_remainder_status) === 1 ? "Start Reminder" : "Stop Reminder"}
              >
                {/* <i className="ri-timer-line" /> */}
                <i
                  className={`ri-timer-line ${Number(row.stop_remainder_status) === 1 ? "text-danger" : "text-success"
                    }`}
                />
              </button>

            </>
          }
        </div>
      ),
      sortable: true,
    },
  ];

  const handleConvert = (row) => {

    if (!row?.pendingId || !row?.orignalId || !row?.access_token) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please complete the contract first",

        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
      });
      return;
    }

    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://api.signeasy.com/v3/rs/envelope/signed/${row.pendingId}/${row.orignalId}/download`,
      headers: {
        Authorization: "Bearer " + row?.access_token,
      },
      responseType: "blob", // Important for binary PDF
    };

    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${row.subject || "document"}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        setLoading(false);

        console.log("Download error:", error);
      });
  };

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",

        customClass: {
          popup: "no-shadow",
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  const handleEdit = (row) => {
    nevigate("/admin/contracts/create-contract", { state: { row: row } });
  };

  const handleDelete = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this contract!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id };
        await dispatch(deleteContract(req))
          .unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: "Deleted!",
                text: "Your Contract has been deleted.",
                icon: "success",
                showConfirmButton: false,
                 timer: 3000,
              });
              AllQuote();
            } else {
              Swal.fire("Error!", "Something went wrong.", "error");
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your quote is safe :)", "error");
      }
    });
  };

  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/contracts/contracts-dashboard">
              <i className="bx bx-arrow-back text-pink"></i>
            </Link>{" "}
            All Contract
          </h4>
        </div>
        <div className="col-auto align-self-center">
          <Link
            to="/admin/contracts/create-contract"
            className="btn btn-pink"
            id="Dash_Date"
          >
            <span className="ay-name" id="Day_Name">
              Add New Contract
            </span>
          </Link>
        </div>
      </div>

      <section className="section dashboard">
        <div className="row">
          <data className="col-lg-3 datatable-search">
            <input
              type="text"
              className="search p-2 icon"
              placeholder="Search here"
              value={InputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </data>
          {/* <div className='col-lg-5'>
            <button className='btn w-auto filter-btn'>
              <i className="bi bi-filter fs-3 text-pink"></i>
            </button>
          </div> */}
        </div>

        <div className="row">
          <Datatable columns={columns} data={allQuoteData} filter={false} />

          {allQuoteData.length > 0 ? <div>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize) || 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />

            <div className="mt-0">

              <select className="perpage-select" value={pageSize} onChange={handlePageSizeChange}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={500}>500</option>
                <option value={0}>{"ALL"}</option>


              </select>
            </div>
          </div> : ""}
        </div>

      </section>
    </div>
  );
};

export default AllQuotes;
